/**
 * Created by pyt on 1/18/17.
 */
export const CLEAR_REFERENCE_DATA = 'CLEAR_REFERENCE_DATA';
export const UPDATE_BUYERS_LIST = 'UPDATE_BUYERS_LIST';
export const UPDATE_CHILDREN_LOCATIONS = 'UPDATE_CHILDREN_LOCATIONS';
export const UPDATE_CURATORS_LIST = 'UPDATE_CURATORS_LIST';
export const UPDATE_DATAPROVIDERS_LIST = 'UPDATE_DATAPROVIDERS_LIST';
export const UPDATE_DEMOGRAPHICS_LIST = 'UPDATE_DEMOGRAPHICS_LIST';
export const UPDATE_EXTERNALDEMOGRAPHICS_LIST = 'UPDATE_EXTERNALDEMOGRAPHICS_LIST';
export const UPDATE_ORGANIZATION_DSP_IDS_LIST = 'UPDATE_ORGANIZATION_DSP_IDS_LIST';
export const UPDATE_EXTERNAL_ORGANIZATION_DSP_IDS_LIST = 'UPDATE_EXTERNAL_ORGANIZATION_DSP_IDS_LIST';
export const UPDATE_ORGANIZATION_DSPS_LIST = 'UPDATE_ORGANIZATION_DSPS_LIST';
export const UPDATE_ORGANIZATION_DSP_BUYERS_LIST = 'UPDATE_ORGANIZATION_DSP_BUYERS_LIST';
export const UPDATE_ORGANIZATION_EXTERNAL_EXCHANGES_LIST = 'UPDATE_ORGANIZATION_EXTERNAL_EXCHANGES_LIST';
export const UPDATE_IAB_CATEGORIES_LIST = 'UPDATE_IAB_CATEGORIES_LIST';
export const UPDATE_LANGUAGE_LIST = 'UPDATE_LANGUAGE_LIST';
export const UPDATE_LOCATION_TREESEARCH_RESULTS = 'UPDATE_LOCATION_TREESEARCH_RESULTS';
export const UPDATE_NETWORKS_LIST = 'UPDATE_NETWORKS_LIST';
export const UPDATE_MARKETS_LIST = 'UPDATE_MARKETS_LIST';
export const UPDATE_MEDIA_OWNERS_LIST = 'UPDATE_MEDIA_OWNERS_LIST';
export const UPDATE_MEDIA_TYPES_LIST = 'UPDATE_MEDIA_TYPES_LIST';
export const UPDATE_SITES_LIST = 'UPDATE_SITES_LIST';
export const UPDATE_TARGETING_CRITERIA_LIST = 'UPDATE_TARGETING_CRITERIA_LIST';
export const UPDATE_SUPPLIER_COUNTRY_ROOTS = 'UPDATE_SUPPLIER_COUNTRY_ROOTS';
export const UPDATE_ALL_UNIT_DIMENSIONS = 'UPDATE_ALL_UNIT_DIMENSIONS';
